var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reader" },
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8", md: "6" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "New Team Name", clearable: "" },
                    model: {
                      value: _vm.newTeam,
                      callback: function($$v) {
                        _vm.newTeam = $$v
                      },
                      expression: "newTeam"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.isSaving || _vm.isLoading,
                        loading: _vm.isSaving,
                        color: "secondary",
                        dense: ""
                      },
                      on: { click: _vm.createTeam }
                    },
                    [_vm._v("Add Team")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.teams,
                      "items-per-page": 15,
                      "item-key": "id",
                      dense: "",
                      "footer-props": {
                        showFirstLastPage: true,
                        itemsPerPageOptions: [-1, 10, 15, 20, 25],
                        firstIcon: "mdi-arrow-collapse-left",
                        lastIcon: "mdi-arrow-collapse-right",
                        prevIcon: "mdi-minus",
                        nextIcon: "mdi-plus"
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.name`,
                          fn: function(props) {
                            return [
                              _c(
                                "v-edit-dialog",
                                {
                                  attrs: {
                                    "return-value": props.item.name,
                                    large: "",
                                    persistent: ""
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        props.item,
                                        "name",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        props.item,
                                        "name",
                                        $event
                                      )
                                    },
                                    save: function($event) {
                                      return _vm.saveName(props.item)
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "input",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "mt-4 title" },
                                              [_vm._v(" Update Name ")]
                                            ),
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Edit",
                                                "single-line": "",
                                                counter: ""
                                              },
                                              model: {
                                                value: props.item.name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "props.item.name"
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [_c("div", [_vm._v(_vm._s(props.item.name))])]
                              )
                            ]
                          }
                        },
                        {
                          key: `item.isDisabled`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-center justify-md-end ma-2"
                                },
                                [
                                  _c("v-simple-checkbox", {
                                    attrs: { dense: "", disabled: "" },
                                    model: {
                                      value: item.isDisabled,
                                      callback: function($$v) {
                                        _vm.$set(item, "isDisabled", $$v)
                                      },
                                      expression: "item.isDisabled"
                                    }
                                  }),
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        disabled: _vm.isLoading || _vm.isSaving,
                                        color: item.isDisabled
                                          ? `success`
                                          : `error`
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleActive(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.isDisabled
                                              ? `Enable`
                                              : `Disable`
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }